const shapeConstants = {
  ARROW: 'Arrow',
  SPHERE: 'Sphere',
  CYLINDER: 'Cylinder',
};

export default shapeConstants;



// WEBPACK FOOTER //
// ./src/constants/shape_constants.js